import styled, { keyframes } from 'styled-components';

const scaleIconInnerPage = keyframes`
    0% {
        transform: scale(0);
    }

    100% {
        transform: scale(1);
        opacity: 1;
    }
`;

const moveIconToTop = keyframes`
    0% {
        opacity: 1;
    }

    100% {
        opacity: 1;
        transform: translateY(-100vh);
    }
`;


const moveOverlayToTop = keyframes`
    100% {
        transform: translateY(-100vh);
    }
`;

export const LoaderWrapper = styled.div<{ isWhite?: boolean }>`
    .loader {
        width: 100vw;
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        top: 0;
        left: 0;
        background-color:${props => props.isWhite ? 'white' : `var(--dark)`};
        z-index: 9999;
        overflow: hidden;
        animation: ${moveOverlayToTop} 2s cubic-bezier(0.87, 0, 0.13, 1) 4.2s forwards;

        &__svg {
            height: 80px;
            transform: scale(0);
    
            @media screen and (max-width: 640px) {
                height: 35px;
            }
    
            img {
                height: 100%;
            }
        }

        &__inner-page {
            animation: ${moveOverlayToTop} 2s cubic-bezier(0.87, 0, 0.13, 1) 1s forwards !important;

            .loader__icon-gradient {
                animation: ${scaleIconInnerPage} .8s cubic-bezier(0.16, 1, 0.3, 1) .1s forwards !important;

                img {
                    animation: ${moveIconToTop} 2s cubic-bezier(0.87, 0, 0.13, 1) 1s forwards;
                }
            }
        }

        &__overlay__inner-page {
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 100%;
            will-change: transform;
            transform: translateY(100vh);
            background-color: ${props => props.isWhite ? `#F6FBEF !important` : `var(--dark) !important`}; 
            animation: ${moveOverlayToTop} 2s cubic-bezier(0.87, 0, 0.13, 1) 1s forwards !important;
            z-index: 10000;
        }
    }
`;